import AnimationClip from '../AnimationClip';
import Armature from '../../../Prototype/Armature';
import {
    defaultDBAnimationName,
    fingerprintMissingDBArmature,
    yieldUntilComplete,
} from '../DBHelpers';
import { report } from '../../../report';
import DragonbonesComponent from '../../../Component/Dragonbones';
import dragonBones from 'pixi-dragonbones';
import { AudioTrackType } from 'System/Audio/AudioClip';
import Game from 'Game';
import { PlaySound } from 'System/Audio/AudioHelper';

export interface DragonbonesDefaultMeta {
    animationName?: string;
    progress?: number;
    playTimes?: number;

    /**
     * Array of bone names to exclusivlely apply an anim to
     */
    boneMasks?: string[];
}

export class DragonbonesDefault extends AnimationClip<DragonbonesDefaultMeta> {
    public *execute(
        gameObject: Armature,
        meta: DragonbonesDefaultMeta = {}
    ): IterableIterator<number> {
        const armatureDisplay = gameObject.container;

        if (!armatureDisplay?.armature) {
            report('Unable to play DragonbonesDefault - missing armature', {
                once: true,
                sampleRate: 0.1,
                tags: {
                    gameObjectName: gameObject.name,
                },
                fingerprint: fingerprintMissingDBArmature,
            });
            return;
        }

        const dbComponent = gameObject.getComponent(DragonbonesComponent);
        const {
            progress = 0,
            animationName = dbComponent.animationName ?? defaultDBAnimationName,
            playTimes = dbComponent.playTimes,
        } = meta;

        const animationState = armatureDisplay.animation.gotoAndPlayByProgress(
            animationName,
            progress,
            playTimes
        );

        if (meta.boneMasks?.length > 0) {
            meta.boneMasks.forEach((boneName: string) => {
                animationState.addBoneMask(boneName);
            });
        }

        // Add sound event listener
        gameObject.on(dragonBones.EventObject.SOUND_EVENT, this.playSound);

        yield* yieldUntilComplete(armatureDisplay);

        // Remove sound event listener
        gameObject.off(dragonBones.EventObject.SOUND_EVENT, this.playSound);
    }

    public readonly playSound = (event: dragonBones.EventObject): void => {
        PlaySound(event.name);
    }
}
